// Terac Scout Partner Program constants. Single source of truth for every
// figure on the page, matching the official Scout Partner Brief (July 2026).
// Flat 5% of a referred business's net approved activity, capped at $50,000 per
// company for the lifetime of the account (the cap does NOT reset), paid
// monthly in USD.
export const SCOUT_RATE = 5;
export const SCOUT_LIFETIME_CAP_USD = 50_000;
// Approx. business activity that reaches the cap at the 5% rate.
export const SCOUT_CAP_ACTIVITY_USD = 1_000_000;
export const SCOUT_CLAWBACK_DAYS = 90;
export const SCOUT_ATTRIBUTION_MONTHS = 12;

// Partnerships intro call: the program's first step is a short call to get a
// unique Scout link, not a self-serve signup route.
export const SCOUT_PRIMARY_CTA_HREF = "https://cal.com/jack-terac/15min";
export const SCOUT_HOW_ANCHOR = "#how-it-works";
